import React from 'react';

const CoveringTypes = (props) => {
    const { bltID, setBltID, bltIDToNames, isDisabled } = props;

    return (
        <div className='form-group col-8 col-md-12'>
            <label>Typ:</label>
            <select className='form-control' value={bltID} disabled={isDisabled} onChange={(event) => setBltID(event.target.value)}>
                {Object.keys(bltIDToNames).map((key) => (
                    <option value={key} key={key}>
                        {bltIDToNames[key]}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default CoveringTypes;
